import * as PIXI from "pixi.js";
import gsap from 'gsap';


export default class ZuhanItem{
    
    constructor($target){
        this.$target = $target;
        this.app = null;
        this.zuhan = null;
        this.displacementFilter = null;
        this._init();
    }
    

    _init(){
        this._create();
        this._createObj();
        this._setYugami();
        this._render();
    }


    _create(){
        this.app = new PIXI.Application({
            width: this.$target.getAttribute('data-cw'),
            height: this.$target.getAttribute('data-ch'),
            backgroundAlpha: 0,
            backgroundColor: 0x000000,
            transparent: true
        });
        this.$target.appendChild(this.app.view);
    }


    _createObj(){
        const tex = window.MyGL._texures[this.$target.getAttribute('data-assets')];
        this.zuhan = new PIXI.Sprite(tex);
        this.zuhan.scale.x = this.zuhan.scale.y = 0.5;
        this.zuhan.x = 0;
        this.zuhan.y = 0;

        this.mask = new PIXI.Sprite(window.MyGL._texures['gradation']);
        this.mask.x = -800;
        this.mask.blendMode = PIXI.BLEND_MODES.DST_OUT;

        this.app.stage.addChild(this.zuhan);
        this.app.stage.addChild(this.mask);
    }


    _setYugami(){
        const noise = window.MyGL._texures['noise'];
        this.displacementFilter = new PIXI.filters.DisplacementFilter(new PIXI.Sprite(noise));
        this.displacementFilter.scale.x = 600;
        this.displacementFilter.scale.y = 100;
        this.zuhan.filters = [this.displacementFilter];

        if(this.$target.getAttribute('data-intractive')=="1"){
            
            this.$target.addEventListener('mouseover', ()=>{
                gsap.to(this.displacementFilter.scale, {duration:0.5, x:60, y:30, ease:'power2.out'});
            });
            this.$target.addEventListener('mouseout', ()=>{
                gsap.to(this.displacementFilter.scale, {duration:0.5, x:0, y:0, ease:'power2.out'});
            });
        }
    }


    _render(){
        const options = {
            threshold: 0.6
        };

        const observer = new IntersectionObserver(entries => {
            this._observerCallback(observer, entries);
        }, options);

        observer.observe(this.$target);
    }


    _observerCallback(observer, entries){

        entries.forEach(entry => {

            if(entry.intersectionRatio > 0){
                gsap.to(this.$target, {duration:0.5, opacity:1, ease:'power2.out'});
                gsap.to(this.mask, {duration:1, x:0, ease:'power2.out'});
                gsap.to(this.displacementFilter.scale, {duration:1, x:0, y:0, ease:'power2.out', onComplete:()=>{
                    this.$target.classList.add('-active');
                    
                    if(this.$target.getAttribute('data-intractive')!="1"){ 
                        this.app.stop();
                    }
                }});
                observer.unobserve(entry.target);
            }
        });
    }
}
